import { PlannedMaintenance as PlannedMaintenancePattern } from '@tumelo/designsystem'
import * as React from 'react'

export const PlannedMaintenance = () => {
  return (
    <PlannedMaintenancePattern
      heading="Planned maintenance: we are currently performing scheduled maintenance. We will be back as soon as possible."
      logoSrc="/images/tumelo_logo_white.png"
    />
  )
}
